const backend_url = (process.env.REACT_APP_MODE === "production") ? process.env.REACT_APP_BACKEND_PRODUCTION_URL : process.env.REACT_APP_BACKEND_DEVELOPMENT_URL;

export const endpoints = {
    login: `${backend_url}/admin/api/login`,
    logout: `${backend_url}/admin/api/logout`,
    getProfile: `${backend_url}/admin/api/profile`,
    getOrdersList: `${backend_url}/admin/api/ordersList`,
    usersCount: `${backend_url}/admin/api/total-users-count`,
    getUsersData: `${backend_url}/admin/api/registeredUsers`,
    getOrdersForSuppliers: `${backend_url}/admin/api/ordersForSupplier`,
    supplierOrdersDashboard: `${backend_url}/admin/api/suppliersOrders`,
    updateProfile: `${backend_url}/admin/api/update/profile`,
    changePassword: `${backend_url}/admin/api/change/password`,
    updateUserStatus: `${backend_url}/admin/api/update/status`,
    usersList: `${backend_url}/admin/api/users/list`,
    addProduct: `${backend_url}/admin/api/supplier/product`,
    getCategoriesList: `${backend_url}/admin/api/categories/list`,
    getUnitsList: `${backend_url}/admin/api/units/list`,
    getProductTypsList: `${backend_url}/admin/api/product/types/list`,
    getSupplierDetail: `${backend_url}/admin/api/users/suppliers`,
    customerRestaurantDetail: `${backend_url}/admin/api/orderList-customer-restaurant`,
    customer_restaurant_order_detail: `${backend_url}/admin/api/orderDetails`,
    getSupplierProducts: `${backend_url}/admin/api/supplier/products`,
    getSuppliersFilterProductTypes: `${backend_url}/admin/api/product/types/list`,
    getSuppliersFilterCategories: `${backend_url}/admin/api/categories/list`,
    addToCart: `${backend_url}/admin/api/add/to/cart`,
    productsAddedToCart: `${backend_url}/admin/api/products/list`,
    orderRequest: `${backend_url}/admin/api/createOrderRequest`,
    getSupplierOrders: `${backend_url}/admin/api/orders`,
    getProducts: `${backend_url}/admin/api/products`,
    addMenu: `${backend_url}/admin/api/menu`,
    getMenuList: `${backend_url}/admin/api/menu`,
    editMenu: `${backend_url}/admin/api/menu`,
    deleteMenu: `${backend_url}/admin/api/menu`,
    getNewsAndEventsList: `${backend_url}/admin/api/news`,
    addNewsAndEvents: `${backend_url}/admin/api/news`,
    editNewsAndEvents: `${backend_url}/admin/api/news/edit`,
    updateFoodCategories: `${backend_url}/admin/api/updateMenuFoodCategory`,
    getFoodCategoriesDropdown: `${backend_url}/admin/api/foodCategoriesListDropdown`,
    getContentFoodCategories: `${backend_url}/admin/api/getFoodCategories`,
    getContentCategories: `${backend_url}/admin/api/categories`,
    getContentProductTypes: `${backend_url}/admin/api/productTypes`,
    updateContent: `${backend_url}/admin/api/content`,
    getContent: `${backend_url}/admin/api/content`,
    addCategory: `${backend_url}/admin/api/add/category`,
    addProductType: `${backend_url}/admin/api/add/productType`,
    addFoodCategories: `${backend_url}/admin/api/addMenuFoodCategory`,
    getQueries: `${backend_url}/admin/api/queries`,
    sendNotification: `${backend_url}/admin/api/send-notification`,
    changeOrderStatus: `${backend_url}/admin/api/order`,
    addUnitsContent: `${backend_url}/admin/api/units`,
    getUnitsListContent: `${backend_url}/admin/api/units`,
    newsAndEventsDetail: `${backend_url}/admin/api/eventDetails`,
    deleteProduct: `${backend_url}/admin/api/product`,
    deleteFoodCategory: `${backend_url}/admin/api/deleteMenuFoodCategory`,
    getReports: `${backend_url}/admin/api/reports-list`,
    deletNewsAndEvents: `${backend_url}/admin/api/news-and-events`,
    deleteQuery: `${backend_url}/admin/api/queries`,
    deleteReports: `${backend_url}/admin/api/reports`,
    getNotification: `${backend_url}/admin/api/getNotifications`,
    getProductTypeRegister: `${backend_url}/api/productTypes`,
    registerSupplier: `${backend_url}/api/register`,
}

export default backend_url;
